import { mapState } from 'vuex'

export default {
  props: ['isFocus', 'loan'],
  computed: {
    ...mapState('ui', ['showErrorMode']),
  },
  watch: {
    /**
     * 해당 믹스인을 사용하려면 data에 agreeForm이 정의되어 있어야 한다
     * agreeForm: {
     *   항목refID: 동의 여부,
     * }
     *
     * ex)
     * agreeForm: {
     *  interestRate: false,
     *  overdueInterestRate: false,
     *  ...
     * }
     *
     * 동의 여부 변화 감지
     */
    agreeForm: {
      handler() {
        const names = Object.getOwnPropertyNames({ ...this.agreeForm })
        this.$emit(
          'update:isComplete',
          names.every((name) => this.agreeForm[name]),
        )
      },
      deep: true,
    },

    /**
     * 완료 검사로직 실행시
     * 미완료 항목으로 스크롤 이동
     */
    showErrorMode: {
      handler(v) {
        if (!v || !this.isFocus) return
        const disagree = this.findDisagree()
        if (!disagree) return

        this.$nextTick(() => {
          setTimeout(() => {
            let ref = this.$refs[disagree]
            // 버튼 컴포넌트인 경우 위치 정보 없는 모달 태그로 감싸져 있을 수 있어서 타겟 더 자세히 설정
            if (ref.$refs?.button?.$el) {
              ref = ref.$refs?.button
            }
            ref?.$el?.scrollIntoView({ behavior: 'smooth', block: 'center' })
          }, 300)
        })
      },
      immediate: true,
    },
  },
  methods: {
    /**
     * @returns 미완료 항목 refID
     */
    findDisagree() {
      const names = Object.getOwnPropertyNames({ ...this.agreeForm })
      return names.find((name) => !this.agreeForm[name])
    },
  },
}
